// This file is automatically generated. Do not edit manually.

import { CustomerOrderOffer } from "src/api/generated/erp/db/types/tables/customerOrderOffer";
import { CustomerOfferSummary } from "src/api/generated/erp/sales/customerOrderOffer/service/customerOfferSummary";
import { CustomerOrderOfferLineView } from "src/api/generated/erp/db/types/tables/customerOrderOfferLineView";
import { AcquisitionMethod } from "src/api/generated/erp/db/types/enums/acquisitionMethod";
import { IsoDateTimeString } from "src/types/dateTime";
import { CustomerOrderOfferState } from "src/api/generated/erp/db/types/enums/customerOrderOfferState";
import { IsoDateString } from "src/types/dateTime";
import { CustomerOrderOfferLineViewSalesPartType } from "src/api/generated/erp/db/types/enums/customerOrderOfferLineViewSalesPartType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderOfferLinesDataGridApi {
	export async function getData(args: {
		customerOrderOfferId: number;
		parentLineId: number | null | undefined;
		searchQuery: string;
	}): Promise<CustomerOrderOfferLinesDataGridApi_Data> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/offerLinesDataGrid/getData",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
				parentLineId: args.parentLineId,
				searchQuery: args.searchQuery,
			},
		});
		return response as CustomerOrderOfferLinesDataGridApi_Data;
	}
}

export interface CustomerOrderOfferLinesDataGridApi_Data {
	customerOrderOffer: CustomerOrderOffer;
	customerOrderOfferLines: Array<CustomerOrderOfferLinesDataGridApi_CustomerOrderOfferLineDto>;
	offerSummary: CustomerOfferSummary;
}

export interface CustomerOrderOfferLinesDataGridApi_CustomerOrderOfferLineDto {
	childLines: Array<CustomerOrderOfferLineView>;
	acquisitionMethod: AcquisitionMethod | null | undefined;
	capacityQuantity: number;
	configurationOrPartDescription: string | null | undefined;
	cost: number;
	costLocked: boolean;
	createdAt: IsoDateTimeString;
	createdByUserId: number;
	currencyCode: string;
	currencyId: number;
	customerId: number;
	customerOrderOfferId: number;
	customerOrderOfferLineId: number;
	customerOrderOfferLineLastUpdated: IsoDateTimeString;
	customerPriceGroupId: number | null | undefined;
	discountFactor: number;
	discountPercentage: number;
	domesticCurrencyCode: string;
	domesticCurrencyId: number;
	externalId: string;
	isAdjustment: boolean;
	isAwaitingConfiguration: boolean;
	lastUpdated: IsoDateTimeString;
	lineNumber: number;
	mark: string;
	offerState: CustomerOrderOfferState;
	orderReference: string;
	parentLineId: number | null | undefined;
	partConfigurationId: number | null | undefined;
	partId: number | null | undefined;
	partIsConfigurable: boolean;
	partUnit: string | null | undefined;
	plannedDeliveryDate: IsoDateString;
	priceInputWithVat: boolean;
	priceLocked: boolean;
	priceUnitFactor: number;
	salesPartDescription: string;
	salesPartId: number;
	salesPartNo: string;
	salesPartType: CustomerOrderOfferLineViewSalesPartType;
	salesPriceUnit: string;
	salesQuantityAsPriceUnits: number;
	salesQuantityAsSalesUnits: number;
	salesQuantityAsWarehouseUnits: number;
	salesUnit: string;
	salesUnitFactor: number;
	salespersonId: number | null | undefined;
	shopOrderBatchCode: string | null | undefined;
	siteId: number;
	totalCost: number;
	totalPrice: number | null | undefined;
	totalPriceWithVat: number | null | undefined;
	unitCost: number;
	unitPrice: number;
	unitPriceWithVat: number;
	vatCodeId: number;
	vatCodeName: string;
	vatPercent: number;
	vatPercentFactor: number | null | undefined;
}
